import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store";
import React from "react";


import ParticipantPanel from "../../panels/Participant";
import NotePadApplication from "../../notepad/index";
import ChatApplication from "widgets/chat-application";
import Whiteboard from "widgets/white-board/WhiteBoard";

import { motion, AnimatePresence } from "framer-motion";
import { FaUserGroup } from "react-icons/fa6";
import { FaSquare } from "react-icons/fa";
import { RxChatBubble } from "react-icons/rx";
import { BiNotepad } from "react-icons/bi";
import { Tooltip } from "@radix-ui/themes";


const LeftPanel = () => {
  const settings = useSelector((state: RootState) => state.live.settings);

  const [activeSubview, setActiveSubview] = useState<
    "chat" | "notepad" | "whiteboard" | "participant"
  >("participant");

  useEffect(() => {
    switch (settings.leftPanel) {
      case "chatPanel":
        setActiveSubview("chat");
        break;
      case "notepadPanel":
        setActiveSubview("notepad");
        break;
      // case "whiteboard":
      //   setActiveSubview("whiteboard");
      //   break;
      case "participantPanel":
      default:
        setActiveSubview("participant");
        break;
    }
  }, [settings.leftPanel]);

  const tabs = [
    { id: "participant", icon: <FaUserGroup size={20} /> },
    // { id: "whiteboard", icon: <FaSquare size={20} /> },
    { id: "chat", icon: <RxChatBubble size={20} /> },
    { id: "notepad", icon: <BiNotepad size={20} /> },
  ] as const;

  return (
    <div className="h-full w-[300px] z-40 bg-[#24272C] rounded-l-3xl overflow-hidden flex flex-col relative">
      <div className="flex-1 overflow-hidden relative p-2 pb-0">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeSubview}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="w-full h-full rounded-2xl overflow-y-auto scrollbar-hide"
          >
            {activeSubview === "chat" && <ChatApplication />}
            {/* {activeSubview === "whiteboard" && <Whiteboard />} */}
            {activeSubview === "notepad" && <NotePadApplication />}
            {activeSubview === "participant" && <ParticipantPanel />}
          </motion.div>
        </AnimatePresence>
      </div>

      {/* Footer Navigation */}
      <div className="bg-[#1E1E2D] rounded-xl m-2 mt-1 flex justify-around py-2 border-t border-gray-700">
        {tabs.map(({ id, icon }) => {
          const isActive = activeSubview === id;
          const label =
            id === "participant"
              ? "Participants"
              : id === "chat"
                ? "Chat"
                : id === "notepad"
                  ? "Notepad"
                  : "Unknown";

          return (
            <Tooltip content={label} key={id} side="top" delayDuration={100}>
              <button
                onClick={() => setActiveSubview(id as any)}
                className={`
            w-9 h-9 rounded-full flex items-center justify-center
            bg-[linear-gradient(320.11deg,#2F3339_14.78%,#15181C_95.73%)]
            shadow-[-4px_-4px_6px_rgba(255,255,255,0.15),4px_4px_6px_rgba(0,0,0,0.2)]
            hover:bg-app-blue/30 transition
          `}
              >
                {React.cloneElement(icon, {
                  className: isActive ? "fill-yellow-400" : "",
                })}
              </button>
            </Tooltip>
          );
        })}
      </div>
    </div>
  );
};

export default LeftPanel;
